import React from 'react'
import { saveAs } from 'file-saver'
import { PDFDownloadLink } from '@react-pdf/renderer'
import GenerarDescargaPdf from '../../Forms/SharedComponents/containers/GenerarDescargaPdf/GenerarDescargaPdf'

function TicketDeDescargaPdf (props) {
  const { detalleLiqMercaderia, versionLaridae, acta } = props

  const savePdf = (url, filename) => {
    props.saveDetalle()
    saveAs(url, filename)
  }

  return (
    <PDFDownloadLink
      document={
        <GenerarDescargaPdf
          data={detalleLiqMercaderia}
          info={{
            version: `${versionLaridae}`,
            acta: `${acta}`
          }}
        />
      }
      fileName={`Certificado de Descarga CTG ${detalleLiqMercaderia.cartaDePorteAutomotor}.pdf`}
      style={{
        textDecoration: 'none',
        padding: '8px 16px',
        marginLeft: '20px',
        color: '#FFFFFF',
        fontSize: '20px',
        height: '60px',
        fontFamily: 'sans-serif',
        backgroundColor: '#007BFF',
        borderRadius: '5px 5px 5px 5px'
      }}
    >
      {({ blob, url, loading, error }) => (
        !loading
          ? savePdf(url, `Certificado de Descarga CTG ${detalleLiqMercaderia.cartaDePorteAutomotor}.pdf`)
          : 'Generando PDF...'
      )}
    </PDFDownloadLink>
  )
}

export default TicketDeDescargaPdf
